
import { VideoPlayer } from '@/components/video-player';
import { useMuxSrcConstructor } from '@/hooks/useMuxSrcConstructor';
import { useNodeProps } from '@/node-editor/hooks';
import { INode, INodeProps } from '@/types/node';
 
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { IContent } from './contract';
import { useTheme, Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

const useStyles =  (theme: Theme) => ({
  root: {
    width: '100% !important',
    aspectRatio: '16/9 !important',
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    color: '#fff !important', 
   
  },
  none: {
    backgroundColor: '#333 ',
  },
});

export const Render = ({
  node: {
    id,
    content: { mediaId },
    override,
  },
  conferenceId,
}: IProps) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const [videoInfo, setVideoInfo] = useState<any | null>(null);

  useEffect(() => {
    mediaId &&
      axios
        .get(`/api/public/media/${mediaId}/videoinfo`)
        .then((res: any) => {
          setVideoInfo({
            ...useMuxSrcConstructor({
              posterToken: res.data.thumbJWT,
              srcToken: res.data.videoJWT,
              playbackId: res.data.playbackId,
              access: 'public',
            }),
            mediaFile: res.data.mediaFile,
          });
        })
        .catch((err: any) => {
          console.error(err);
          setVideoInfo({
            error: err.response.data.message || 'Error loading video',
            status: err.response.status,
          });
        });
  }, [mediaId]);

  return (
    <Box 
      sx={{
        ...classes.root,
        ...( (!mediaId || (videoInfo && videoInfo.error)) && classes.none ),
        ...override.root,
      }}
      {...useNodeProps(id)}
    >
      {!mediaId && <div>No video selected</div>}
      {videoInfo &&
        (videoInfo.error ? (
          <div>
            {videoInfo.status === 401
              ? (window as any).LANG.AUTH_REQUIRED
              : videoInfo.error}
          </div>
        ) : (
          <VideoPlayer
            source={videoInfo}
            trackingdata={{
              programroomId: 'Widget',
              videoTitle: videoInfo.mediaFile.original_filename,
            }}
          ></VideoPlayer>
        ))}
    </Box>
  );
};
